import { Link } from "react-router-dom";

export default function BlogCard({ blog }) {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition duration-300">
      <img src={blog.image} alt="blog" className="w-full h-52 object-cover" />
      <div className="p-4">
        <h2 className="text-2xl font-semibold">{blog.title}</h2>
        <p className="text-gray-600 mt-2">{blog.description}</p>
        <Link to={`/blog/${blog.id}`} className="text-blue-600 font-medium mt-4 inline-block">
          Read More →
        </Link>
      </div>
    </div>
  );
}
